export const typesFinancialsSettings = [
  { label: "Default", value: "1" },
  { label: "Campanha", value: "2" },
];
